<svg width="40" height="40" viewBox="3 3 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.9" d="M10 10L20 20M30 30L20 20M20 20L30 10M20 20L10 30" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
